define("powergen/models/manager",
  [],
  function() {
    "use strict";
    var Manager;

    Manager = Ember.Object.create({
      init: function() {
        return this.resetUser();
      },
      gameWasCompleted: false,
      "static": window["static"],
      resetUser: function() {
        return this.set('user', Ember.Object.create({
          firstName: '',
          lastName: '',
          email: '',
          score: 0
        }));
      }
    });


    return Manager;
  });